import styles from './relation-product-context.module.scss';
import { createContext, useEffect, useState } from 'react';
import { makeRequest } from '../requestUtils';
import { iRelationProductGroups } from '@frontend-workspace/react-shared-lib';
import { IRelationProduct } from '../_models/relation-product';

/* eslint-disable-next-line */
export interface RelationProductContextProps { }

export const RelationProductGroupContext = createContext<Array<IRelationProduct>>([]);
export const RelationProductgroupUpdateContext = createContext<Function | undefined>(undefined);
export const RelationProductProvider = ({ children }: { children: React.ReactNode }) => {
  const [relationProducts, setRelationProducts] = useState<Array<IRelationProduct>>([]);

  useEffect(() => {
    //makeRequest(`relationProductGroups`).then((productGroups: Array<iRelationProductGroups>) => {
    makeRequest("relationProducts").then((productGroups: Array<IRelationProduct>) => {
      setRelationProducts(productGroups);
    });
  }, []);

  return (
    <RelationProductgroupUpdateContext.Provider value={setRelationProducts}>
      <RelationProductGroupContext.Provider value={relationProducts}>
        {children}
      </RelationProductGroupContext.Provider>
    </RelationProductgroupUpdateContext.Provider>
  );
}